import loadable from "@loadable/component";
import { GridContainer, GridItem, GridRow, gridConfig } from "@tvg/fuse-design/responsive-grid";
import { Tabs as FuseTabs, TabPanel } from "@tvg/fuse-design/tabs";
import useTabConfig from "client/context/TabContext";
import getPLPRoot from "client/utils/getPLPRoot";
import React, { KeyboardEvent, MouseEvent, useCallback, useEffect, useMemo } from "react";
import styled from "styled-components";
import { ALL_PRODUCTS_LABEL } from "./config";

const TabContentFactory = loadable(() => import(/* webpackChunkName: "TabContentFactory" */ "./TabContentFactory"), {
  resolveComponent: (m) => m.TabContentFactory,
});

const StyledGridContainer = styled(GridContainer)`
  @media only screen and (max-width: ${gridConfig.m.maxWidth}) {
    && {
      padding: 0;
    }
  }
`;

const togglePLP = (on: boolean) => {
  const plpRootEl = getPLPRoot();
  if (!plpRootEl) return;

  plpRootEl.style.display = on ? "" : "none";
};

const Tabs = () => {
  const { tabs, defaultTab } = useTabConfig();

  const tabsArr = useMemo(
    () =>
      tabs?.tabs?.length && [
        {
          label: ALL_PRODUCTS_LABEL,
          content: [{ _meta: { schema: "", deliveryId: "" }, id: "" }],
          _meta: { schema: "", deliveryId: "" },
        },
        ...tabs.tabs,
      ],
    [tabs],
  );

  const handleTabChange = useCallback((e: MouseEvent | KeyboardEvent) => {
    const el = e.target;
    if (!(el instanceof HTMLButtonElement)) return;
    if (!el.classList.contains("fuse-tabs__tab")) return;

    const titleEl = el.querySelector<HTMLParagraphElement>("p.fuse-tabs__tab-label");
    const title = titleEl?.getAttribute("title");
    if (!title) return;

    togglePLP(title === ALL_PRODUCTS_LABEL);
  }, []);

  useEffect(() => {
    togglePLP(typeof defaultTab !== "number" || defaultTab === 1);
  }, [defaultTab]);

  if (!tabsArr) return null;
  return (
    <StyledGridContainer>
      <GridRow>
        <GridItem xxs="12">
          <FuseTabs
            tabListAriaLabel={tabs?.tabListAriaLabel || "Tabs of the current page"}
            landOnTab={defaultTab || 1}
            onClick={handleTabChange}
            onFocus={handleTabChange}
            dataTestId="content-tabs"
          >
            {tabsArr.map(({ label, content, _meta: tabMeta }) => (
              <TabPanel key={label} label={label}>
                <TabContentFactory key={tabMeta.deliveryId} content={content} />
              </TabPanel>
            ))}
          </FuseTabs>
        </GridItem>
      </GridRow>
    </StyledGridContainer>
  );
};

export default Tabs;
